module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"confirmOrderRemovalTrip":"Are you sure you want to remove the selected order from trip {tripNumber}?"},"no":{"confirmOrderRemovalTrip":"Er du sikker på at du vil fjerne den valgte oppdrag fra turen {tripNumber}?"}}')
  delete Component.options._Ctor
}
